import { render, staticRenderFns } from "./AstaAssegnaHeaderActions.vue?vue&type=template&id=4d49c19d&scoped=true&"
import script from "./AstaAssegnaHeaderActions.vue?vue&type=script&lang=js&"
export * from "./AstaAssegnaHeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./AstaAssegnaHeaderActions.vue?vue&type=style&index=0&id=4d49c19d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d49c19d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d49c19d')) {
      api.createRecord('4d49c19d', component.options)
    } else {
      api.reload('4d49c19d', component.options)
    }
    module.hot.accept("./AstaAssegnaHeaderActions.vue?vue&type=template&id=4d49c19d&scoped=true&", function () {
      api.rerender('4d49c19d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AstaAssegnaHeaderActions.vue"
export default component.exports